import { lazy } from "react";
import withSuspense from "../../../helpers/withSuspense";
import LexicalSkeleton from "./LexicalSkeleton";

const LexicalEditor = withSuspense(lazy(()=>import('./LexicalEditor')), (props) => <LexicalSkeleton className={props.skeletonClassName} />);

export default LexicalEditor;